// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"5347127e","98":"4c7ee59e","233":"7921e0aa","355":"fafc9336","377":"464749b2","392":"bc9e1d8f","453":"e931e070","455":"c4989ece","576":"a314b878","739":"6ac71d0d","844":"f4e866f6","977":"163cea99"}[chunkId] + ".chunk.js";
};